export var ShippingRuleStatus;
(function (ShippingRuleStatus) {
    ShippingRuleStatus["MissingZipCode"] = "MissingZipCode";
    ShippingRuleStatus["NoShipppingToDestination"] = "NoShipppingToDestination";
    ShippingRuleStatus["UnsupportedRegion"] = "UnsupportedRegion";
    ShippingRuleStatus["OK"] = "OK";
    ShippingRuleStatus["FullAddressRequired"] = "FullAddressRequired";
})(ShippingRuleStatus || (ShippingRuleStatus = {}));
//# sourceMappingURL=shipping-rule-status.js.map